import React, { useEffect, useRef, useState } from "react";

// Renders children once the placeholder is near the viewport (or after idle / a hard timeout),
// so below-the-fold chunks stop competing with the hero for main-thread time on first load.
// Nothing is removed: everything still mounts, just a bit later.
const Deferred = ({ children, minHeight = 240, rootMargin = "800px 0px", timeout = 3500 }) => {
  const ref = useRef(null);
  const [show, setShow] = useState(() => typeof IntersectionObserver === "undefined" || (typeof window !== "undefined" && window.location.hash !== ""));

  useEffect(() => {
    if (show) return undefined;
    const el = ref.current;
    const io = new IntersectionObserver((entries) => {
      if (entries.some((e) => e.isIntersecting)) { setShow(true); io.disconnect(); }
    }, { rootMargin });
    if (el) io.observe(el);
    const idle = window.requestIdleCallback ? window.requestIdleCallback(() => setShow(true), { timeout }) : window.setTimeout(() => setShow(true), timeout);
    return () => {
      io.disconnect();
      if (window.cancelIdleCallback) window.cancelIdleCallback(idle); else window.clearTimeout(idle);
    };
  }, [show, rootMargin, timeout]);

  return show ? children : <div ref={ref} style={{ minHeight }} aria-hidden="true" />;
};

export default Deferred;
